module.exports = __webpack_public_path__ + "img/skillgames-spider-web.0688bfc1.jpg";